const FEEDBACK_BASE_URL =
  'https://hk-paas.transsion.com/ai-ops-front/#/feedback/bpm'

const FIELD_ERROR_MESSAGE = '\u62a5\u9519\u4fe1\u606f'
const FIELD_PROCESS_LINK = '\u6d41\u7a0b\u94fe\u63a5'
const FIELD_SCREENSHOT = '\u9875\u9762\u5feb\u7167'

function appendParam(parts, key, value) {
  if (value === undefined || value === null || value === '') return
  parts.push(`${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
}

function buildFeedbackUrl(params = {}) {
  const query = []

  appendParam(query, 'feedbackEmployeeNo', params.employeeNo)
  appendParam(query, 'P-token', params.token)
  appendParam(query, 'P-Rtoken', params.rtoken)
  if (params.text) {
    appendParam(query, `prefill_${FIELD_ERROR_MESSAGE}`, params.text)
    appendParam(query, `hide_${FIELD_ERROR_MESSAGE}`, '1')
  }

  appendParam(query, `prefill_${FIELD_PROCESS_LINK}`, params.pageUrl)
  appendParam(query, `hide_${FIELD_PROCESS_LINK}`, '1')

  if (params.screenshotPath) {
    appendParam(query, `prefill_${FIELD_SCREENSHOT}`, params.screenshotPath)
    appendParam(query, `hide_${FIELD_SCREENSHOT}`, '1')
  }

  return `${FEEDBACK_BASE_URL}?${query.join('&')}`
}

module.exports = {
  buildFeedbackUrl,
}
